/**
 * File: ServiceRequests.js
 * Origin: isotect
 * Description: Functions that handle service requests.
 *
 * Version: v1.1.0
 * Created: 2026-04-08
 * Last Updated: 2026-06-23
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

/**
 * [TODO: Function description here]
 */
async function signUp(firstName, lastName, email, password) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_AUTHENTICATION_URL}/sign-up`,
            {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    firstName,
                    lastName,
                    email,
                    password,
                }),
            },
        );

        if (!response.ok) {
            if (response.status === 409) {
                throw new Error(
                    "An account with this email already exists. Please sign in or use a different email.",
                );
            }
            throw new Error(
                "Unable to create account at this time. Please try again later.",
            );
        }

        const result = await response.json();
        sessionStorage.setItem("accessToken", result.data.accessToken);
    } catch (error) {
        throw new Error(error.message);
    }
}

/**
 * [TODO: Function description here]
 */
async function signIn(email, password, rememberMe) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_AUTHENTICATION_URL}/sign-in`,
            {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                    password,
                    rememberMe,
                }),
            },
        );

        if (!response.ok) {
            throw new Error("Sign-in failed");
        }

        const result = await response.json();
        sessionStorage.setItem("accessToken", result.data.accessToken);
    } catch (error) {
        throw new Error(error.message);
    }
}

/**
 * [TODO: Function description here]
 */
async function signOut() {}

/**
 * [TODO: Function description here]
 *
 * @param {*} email
 */
async function sendOtpCode(email) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_AUTHENTICATION_URL}/send-otp`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email,
                }),
            },
        );

        if (!response.ok) {
            throw new Error("Forgot password request failed");
        }
    } catch (error) {
        throw new Error(error.message);
    }
}

/**
 * [TODO: Function description here]
 *
 * @param {*} email
 * @param {*} code
 */
async function verifyOtpCode(email, code) {
    const response = await fetch(
        `${process.env.REACT_APP_AUTHENTICATION_URL}/verify-otp`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email,
                code,
            }),
        },
    );

    if (!response.ok) {
        throw new Error("OTP verification failed");
    }
}

/**
 * [TODO: Function description here]
 *
 * @param {*} password
 */
async function resetPassword(email, password) {
    const response = await fetch(
        `${process.env.REACT_APP_AUTHENTICATION_URL}/reset-password`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email,
                password,
            }),
        },
    );

    if (!response.ok) {
        throw new Error("Password reset failed");
    }
}

/**
 * [TODO: Function description here]
 */
async function fetchOrderData() {
    const accessToken = sessionStorage.getItem("accessToken");

    const response = await fetch(
        `${process.env.REACT_APP_ORDER_URL}/app-data`,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        },
    );

    if (!response.ok) {
        throw new Error("Estimates fetch request failed");
    }

    return response.json();
}

/**
 * [TODO: Function description here]
 *
 * @param {*} estimateId
 * @param {*} status
 */
async function updateEstimateStatus(estimateId, status) {
    const accessToken = sessionStorage.getItem("accessToken");

    const response = await fetch(
        `${process.env.REACT_APP_ORDER_URL}/estimates/${estimateId}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({
                estimateStatus: status,
            }),
        },
    );

    if (!response.ok) {
        throw new Error("Work order approval failed");
    }

    return response.json();
}

export {
    signIn,
    signUp,
    signOut,
    sendOtpCode,
    verifyOtpCode,
    resetPassword,
    fetchOrderData,
    updateEstimateStatus,
};
